export enum TripDelayType {
  ON_TIME = 'ON_TIME',
  LATE = 'LATE',
  LIKELY_LATE = 'LIKELY_LATE',
  UNKNOWN = 'UNKNOWN'
}
